import React from "react";
import { Box, Tooltip } from "@mui/joy";
import { PhotoCameraIcon, UploadFileIcon } from "../../../styles/StyledMUI";
import IconButtonCTA from "../../common/IconButtonCTA";
import { roundActionIconButtonSx } from "../../../styles/globalStyles";
import {
  PORTAL_CAMERA_ACCEPT,
  PORTAL_DOCUMENT_ACCEPT,
  pickPortalDocumentFile,
} from "../../../utils/documentUpload";

type DocumentUploadButtonsProps = {
  onFile: (file: File) => void;
  onInvalidFile: () => void;
  onLoadingChange?: (loading: boolean) => void;
};

export default function DocumentUploadButtons({
  onFile,
  onInvalidFile,
  onLoadingChange,
}: DocumentUploadButtonsProps) {
  const fileInputRef = React.useRef<HTMLInputElement | null>(null);
  const cameraInputRef = React.useRef<HTMLInputElement | null>(null);

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    onLoadingChange?.(true);
    try {
      await pickPortalDocumentFile(event, onFile, onInvalidFile);
    } finally {
      onLoadingChange?.(false);
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <input
        ref={fileInputRef}
        style={{ display: "none" }}
        type="file"
        accept={PORTAL_DOCUMENT_ACCEPT}
        onChange={handleChange}
      />
      <input
        ref={cameraInputRef}
        style={{ display: "none" }}
        type="file"
        accept={PORTAL_CAMERA_ACCEPT}
        capture="environment"
        onChange={handleChange}
      />
      <Tooltip title="PDF ou photo">
        <IconButtonCTA
          size="lg"
          ctaVariant="accent"
          aria-label="Ajouter un document PDF ou une photo"
          onClick={() => fileInputRef.current?.click()}
          sx={roundActionIconButtonSx}
        >
          <UploadFileIcon />
        </IconButtonCTA>
      </Tooltip>
      <Box sx={{ display: { xs: "inline-flex", md: "none" } }}>
        <Tooltip title="Prendre une photo">
          <IconButtonCTA
            size="lg"
            ctaVariant="accent"
            aria-label="Prendre une photo du document"
            onClick={() => cameraInputRef.current?.click()}
            sx={roundActionIconButtonSx}
          >
            <PhotoCameraIcon />
          </IconButtonCTA>
        </Tooltip>
      </Box>
    </Box>
  );
}
